"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtherContract = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var cashLoanAuth_1 = require("../../model/cashLoanAuth");
var service_1 = require("../../../library/base/service");
var OtherContract = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(OtherContract, _super);
    function OtherContract() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '现金贷其它联系人关系接口';
        _this.code = '101124';
        _this.desc = '现金贷其它联系人关系接口';
        _this.requestParams = new cashLoanAuth_1.OtherContractRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return OtherContract;
}(service_1.BaseService));
exports.OtherContract = OtherContract;
//# sourceMappingURL=otherContract.js.map